import { CalendarDate } from "@sp-crm/core";
import * as React from "react";

interface ReadOnlyDateFieldProps {
    label: string;
    value: string | null;
}

const formatValue = (value: string | null): string => {
    if (!value) {
        return "—";
    }
    const parsed = CalendarDate.parse(value).getOrElse(null);
    return parsed ? parsed.humanFriendly() : "—";
};

export const ReadOnlyDateField: React.FC<ReadOnlyDateFieldProps> = ({ label, value }) => (
    <div className="w-full">
        {label ? <div className="mb-1">{label}</div> : null}
        <div
            data-testid="read-only-date-field"
            className="form-input rounded-sm md:rounded w-full bg-gray-100 border-gray-300 text-gray-700">
            {formatValue(value)}
        </div>
    </div>
);
